import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatInput } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { ClientDetailComponent } from 'src/app/client/client-detail/client-detail.component';
import { CategoryModel } from 'src/app/shared/models/category.model';
import { ClientModel } from 'src/app/shared/models/client.model';
import { RmaMasterDetailModel, RmaMasterModel, ShippingArrivalModel } from 'src/app/shared/models/rma.model';
import { ClientService } from 'src/app/shared/services/client.service';
import { CourierService } from 'src/app/shared/services/courier.service';
import { RmaMasterService } from 'src/app/shared/services/rma-master.service';
import { RmaService } from 'src/app/shared/services/rma.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-rma-shipping-arrivals-edit',
  templateUrl: './rma-shipping-arrivals-edit.component.html',
  styleUrls: ['./rma-shipping-arrivals-edit.component.css']
})
export class RmaShippingArrivalsEditComponent implements OnInit, OnDestroy{
  form : FormGroup = ShippingArrivalModel.getFormGroup();
  listCourier : CategoryModel [];
  listClient : ClientModel [];
  listCode : RmaMasterDetailModel [];
  listFindClient : ClientModel[];
  listFindCode : RmaMasterDetailModel[];
  selectedClient1 : ClientModel;
  selectedClient2 : ClientModel;
  selectedCode : RmaMasterDetailModel;
  dialogConfig = new MatDialogConfig();
  currentData : ShippingArrivalModel;
  searchKey : string;
  searchCodeKey : string;
  @ViewChild('searchInput', {static: false}) searchInput :ElementRef;
  @ViewChild('searchCodeInput', {static: false}) searchCodeInput :ElementRef;
  private sub: any;
  @Input() selectedInputType : string;

  constructor(
    private service : RmaService,
    private rmaMasterService : RmaMasterService,
    private courierService : CourierService,
    private clientService : ClientService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private dialog : MatDialog,
    private router : Router,
    private aroute: ActivatedRoute,
  ) {

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.width = "60%";
    this.dialogConfig.minWidth = "400px";
    this.dialogConfig.maxWidth = "700px";

    this.selectedInputType = "1";
  }
  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
    this.sub.unsubscribe();
  }

  ngOnInit() {
    this.currentData = new ShippingArrivalModel();
    this.loadCourierList();
    this.loadClientList(null);
    this.loadRmaList();

    this.sub = this.aroute.params.subscribe(params => {
       var id = params['id'];
       console.log("id : " + id);
       if(id != null)
       {
          this.service.getDetail(id).subscribe(
            res=>{
              this.currentData = res as ShippingArrivalModel;
             // this.form.setValue(this.currentData);
             this.selectedInputType = "2";
              if( this.listClient)
              {
                 this.listFindClient = this.listClient.filter(x=>x.clientId === this.currentData.clientId);
                 this.selectedClient1 = this.selectedClient2 = this.listFindClient[0];
              }
            },
            err=>{
              console.log(err);
            }
          );
       }

      });



  }
  loadCourierList(){
    this.courierService.getList().subscribe(
      res=>{
        this.listCourier = res as CategoryModel[];
      },
      err=>{}
    );
  }

  loadClientList(data){
    console.log("loadClientList");
    this.clientService.getList().subscribe(
      res=>{
        this.listClient = res as ClientModel[];
        if(data)
        {
//          this.form.value.clientId = data.clientId;
          this.listFindClient = this.listClient.filter(x=>x.clientId === data.clientId);
          this.form.controls['clientId'].setValue(data.clientId);
          this.selectedClient2 = this.listFindClient[0];
        }
        else{
          if(this.currentData){
            this.listFindClient = this.listClient.filter(x=>x.clientId === this.currentData.clientId);
            this.selectedClient2 = this.listFindClient[0];
          }
        }
      },
      err=>{}
    );
  }

  loadRmaList()
  {
    console.log("loadClientList");
    this.rmaMasterService.getList().subscribe(
      res=>{
        this.listCode = res as RmaMasterDetailModel[];
        if(this.currentData){
          this.listFindClient = this.listClient.filter(x=>x.clientId === this.currentData.clientId);
          this.selectedClient1 = this.listFindClient[0];
        }
      },
      err=>{}
    );

  }

  onCourierChangeAction(data)
  {
    console.log(data);
  }

  onKey(data)
  {
    this.searchKey = data;
    if(!data || data.length == 0)
    {
          this.listFindClient = null;
    }
    else
    {
      var temp = data.toLowerCase();
      this.listFindClient = this.listClient.filter(x =>  x.fullName.toLowerCase().includes(temp)
                || (x.company != null && x.company.toLowerCase().includes(temp)));
    }
  }

  onCodeKey(data)
  {
    this.searchCodeKey = data;
    if(!data || data.length == 0)
    {
      this.listFindCode = null;
    }
    else
    {
      var temp = data.toLowerCase();
      this.listFindCode = this.listCode.filter(x => x.rmaCode != null && x.rmaCode.toLowerCase().includes(temp));
    }
  }
  onSearchClear()
  {
    console.log("onSearchClear");
    this.searchInput.nativeElement.value = '';
    this.searchKey = "";
    this.listFindClient = null;
  }

  onSearchCodeClear()
  {
    console.log("onSearchCodeClear");
    this.searchCodeInput.nativeElement.value = '';
    this.searchCodeKey = "";
    this.listFindCode = null;
  }

  onClientChangeAction(data)
  {
    console.log(data);
    this.selectedClient2 = this.listClient.find(x=>x.clientId === data.value);

  }

  onRmaCodeChangeAction(data)
  {
    console.log(data);
    this.selectedCode = this.listCode.find(x=>x.rmaCode === data.value);
    this.selectedClient1 = this.listClient.find(x=>x.clientId === this.selectedCode.clientId);
  }

  onSave()
  {
    console.log("Save Shipping Arrival");
    if(this.selectedInputType == "1")
    {
      this.currentData.clientId = this.selectedClient1.clientId;
    }
    else{
      this.currentData.clientId = this.selectedClient2.clientId;
    }
      if (this.currentData.rmaCode == null
        || this.currentData.clientId == null
      || this.currentData.courierId == null
      || this.currentData.arrivalDate == null) {
        ////this.toastr.warning("Pleaes check all the mendatory inputs.", "Invalid");
        this.gnotify.showSnackBar('Invalid', 'Pleaes check all the mendatory inputs.', "warning");
        return;
      }

      if (this.currentData.arrivalId == null){ // new
        this.service.insertData(this.currentData).subscribe(
          res=>{
              ////this.toastr.success("Submit successfuly", "RMA Shipping Arrival Create");
              this.gnotify.showSnackBar('RMA Shipping Arrival Create', 'Submit successfuly', "success");
              this.router.navigateByUrl('rma-shipping-arrivals');
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "RMA Shipping Arrival Create");
            this.gnotify.showSnackBar('RMA Shipping Arrival Create', 'Failed to Submit', "error");
            return;
          }
          );
      }
      else{
        this.service.updateData(this.currentData).subscribe(
          res=>{
            ////this.toastr.success("Submit successfuly", "RMA Shipping Arrival Modify");
            this.gnotify.showSnackBar('RMA Shipping Arrival Modify', 'Submit successfuly', "success");
            this.router.navigateByUrl('rma-shipping-arrivals');
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "RMA Shipping Arrival Modify");
            this.gnotify.showSnackBar('RMA Shipping Arrival Modify', 'Failed to Submit', "error");
            return;
          }
          );

      }

  }
  radioChange(event) {
    console.log(event);
 }

  onCreateClient()
  {
    this.clientService.initializeFormGroup();

    this.dialogConfig.data = {
      result : false,
      data : null
    };

    let dialogRef = this.dialog.open(ClientDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.loadClientList(this.dialogConfig.data.data);
      }

    });
  }

  onEditClient(data){
    this.clientService.populateForm(data);

    this.dialogConfig.data = {
      result : false,
      data : data
    };

    let dialogRef = this.dialog.open(ClientDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
       // this.selectedClient2 = null;
        this.loadClientList(null);
      }

    });
  }
}
